import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchApiData } from "../../store/slicers/apiSlicer.js";
import AppLayout from "../layouts/AppLayout.jsx";

const ContentDocuments = () => {
  const dispatch = useDispatch();
  const [categories, setCategories] = useState([]);
  const [expandedCategories, setExpandedCategories] = useState([]);
  const [currentLang, setCurrentLang] = useState(() => {
    return localStorage.getItem("onpr_language") || "fr";
  });

  const { data, isLoading } = useSelector((state) => ({
    data: state.apiData?.data?.documents,
    isLoading: state.apiData?.loading?.documents,
  }));

  useEffect(() => {
    dispatch(
      fetchApiData({
        url: "downloawddoc",
        itemKey: "documents",
      }),
    );
  }, []);

  useEffect(() => {
    if (data) {
      setCategories(data);
      // Expand all categories by default
      setExpandedCategories(data.map((cat) => cat.id));
    }
  }, [data]);

  const toggleCategory = (categoryId) => {
    setExpandedCategories((prev) =>
      prev.includes(categoryId)
        ? prev.filter((id) => id !== categoryId)
        : [...prev, categoryId],
    );
  };

  const getCategoryTitle = (category) => {
    return currentLang === "fr"
      ? category.title
      : category.title_en || category.title;
  };

  const getDocumentTitle = (document) => {
    return currentLang === "fr"
      ? document.title
      : document.title_en || document.title;
  };

  const handleDownload = (documentUrl, documentTitle) => {
    window.open(documentUrl, "_blank");
  };

  if (isLoading) {
    return (
      <div className="documents-container">
        <h2 className="section-title">Services en ligne - Documents</h2>
        <div className="text-center py-5">
          <i
            className="pi pi-spin pi-spinner"
            style={{ fontSize: "3rem", color: "#00a652" }}
          ></i>
          <p>Chargement des documents...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="documents-container">
      <div className="documents-header">
        <h2 className="section-title">Services en ligne - Documents</h2>
        <p className="section-description">
          Téléchargez les formulaires, décisions et documents officiels de
          l'ONPR
        </p>
      </div>

      {categories.length === 0 ? (
        <div className="no-data-placeholder">
          <i
            className="pi pi-inbox"
            style={{ fontSize: "4rem", color: "#ccc" }}
          ></i>
          <p>Aucun document disponible</p>
        </div>
      ) : (
        <div className="categories-list">
          {categories.map((category) => (
            <div key={category.id} className="category-card">
              <div
                className="category-header"
                onClick={() => toggleCategory(category.id)}
              >
                <div className="category-title-section">
                  <div className="category-icon">
                    <i className="pi pi-folder"></i>
                  </div>
                  <h3 className="category-title">
                    {getCategoryTitle(category)}
                  </h3>
                  <span className="document-count">
                    {category.documents.length} document
                    {category.documents.length > 1 ? "s" : ""}
                  </span>
                </div>
                <i
                  className={`pi pi-chevron-${
                    expandedCategories.includes(category.id) ? "up" : "down"
                  } toggle-icon`}
                ></i>
              </div>

              {expandedCategories.includes(category.id) && (
                <div className="documents-list">
                  {category.documents.map((document) => (
                    <div key={document.id} className="document-item">
                      <div className="document-info">
                        <i className="pi pi-file-pdf document-icon"></i>
                        <div className="document-details">
                          <span className="document-title">
                            {getDocumentTitle(document)}
                          </span>
                          <span className="document-date">
                            Ajouté le{" "}
                            {new Date(document.created_at).toLocaleDateString(
                              "fr-FR",
                            )}
                          </span>
                        </div>
                      </div>
                      <button
                        className="download-btn"
                        onClick={() =>
                          handleDownload(
                            document.name,
                            getDocumentTitle(document),
                          )
                        }
                        title="Télécharger le document"
                      >
                        <i className="pi pi-download"></i>
                        Télécharger
                      </button>
                    </div>
                  ))}
                </div>
              )}
            </div>
          ))}
        </div>
      )}

      <style jsx>{`
        .documents-container {
          max-width: 1000px;
          margin: 30px auto;
          padding: 0 20px;
        }
        .documents-header {
          margin-bottom: 30px;
        }
        .section-title {
          color: #00a652;
          font-size: 1.8rem;
          margin: 0 0 10px 0;
          padding-bottom: 15px;
          border-bottom: 4px solid #d32f2f;
          position: relative;
        }
        .section-title::before {
          content: "";
          position: absolute;
          bottom: -4px;
          left: 0;
          width: 100px;
          height: 4px;
          background: #00a652;
        }
        .section-description {
          color: #666;
          font-size: 1rem;
          margin-top: 15px;
        }
        .categories-list {
          display: flex;
          flex-direction: column;
          gap: 20px;
        }
        .category-card {
          background: white;
          border-radius: 12px;
          box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
          overflow: hidden;
          border-left: 5px solid #00a652;
          transition: all 0.3s;
        }
        .category-card:hover {
          box-shadow: 0 6px 25px rgba(0, 0, 0, 0.15);
        }
        .category-header {
          padding: 20px 25px;
          display: flex;
          justify-content: space-between;
          align-items: center;
          cursor: pointer;
          background: linear-gradient(
            to right,
            rgba(26, 95, 58, 0.05),
            transparent
          );
          transition: background 0.3s;
        }
        .category-header:hover {
          background: linear-gradient(
            to right,
            rgba(26, 95, 58, 0.1),
            transparent
          );
        }
        .category-title-section {
          display: flex;
          align-items: center;
          gap: 15px;
          flex: 1;
        }
        .category-icon {
          width: 50px;
          height: 50px;
          background: linear-gradient(135deg, #00a652 0%, #2d8659 100%);
          border-radius: 10px;
          display: flex;
          align-items: center;
          justify-content: center;
          flex-shrink: 0;
        }
        .category-icon i {
          font-size: 1.5rem;
          color: white;
        }
        .category-title {
          color: #00a652;
          font-size: 1.2rem;
          font-weight: 600;
          margin: 0;
        }
        .document-count {
          background: #d32f2f;
          color: white;
          padding: 4px 12px;
          border-radius: 20px;
          font-size: 0.85rem;
          font-weight: 600;
        }
        .toggle-icon {
          color: #00a652;
          font-size: 1.2rem;
          transition: transform 0.3s;
        }
        .documents-list {
          padding: 0 25px 20px 25px;
          display: flex;
          flex-direction: column;
          gap: 12px;
        }
        .document-item {
          display: flex;
          justify-content: space-between;
          align-items: center;
          padding: 15px;
          background: #f8f9fa;
          border-radius: 8px;
          border-left: 3px solid #00a652;
          transition: all 0.3s;
        }
        .document-item:hover {
          background: #e9ecef;
          transform: translateX(5px);
        }
        .document-info {
          display: flex;
          align-items: center;
          gap: 15px;
          flex: 1;
        }
        .document-icon {
          font-size: 2rem;
          color: #d32f2f;
          flex-shrink: 0;
        }
        .document-details {
          display: flex;
          flex-direction: column;
          gap: 5px;
        }
        .document-title {
          color: #333;
          font-weight: 500;
          font-size: 0.95rem;
          line-height: 1.4;
        }
        .document-date {
          color: #999;
          font-size: 0.8rem;
        }
        .download-btn {
          background: #00a652;
          color: white;
          border: none;
          padding: 10px 20px;
          border-radius: 5px;
          cursor: pointer;
          display: flex;
          align-items: center;
          gap: 8px;
          font-weight: 600;
          font-size: 0.9rem;
          transition: all 0.3s;
          white-space: nowrap;
          flex-shrink: 0;
        }
        .download-btn:hover {
          background: #d32f2f;
          transform: translateY(-2px);
        }
        .download-btn i {
          font-size: 1rem;
        }
        .no-data-placeholder {
          text-align: center;
          padding: 60px 20px;
        }
        .no-data-placeholder p {
          color: #999;
          font-size: 1.1rem;
          margin-top: 15px;
        }
        .text-center {
          text-align: center;
        }
        .py-5 {
          padding-top: 3rem;
          padding-bottom: 3rem;
        }
        @media (max-width: 768px) {
          .category-title-section {
            flex-wrap: wrap;
          }
          .category-title {
            font-size: 1rem;
            flex: 1 1 100%;
          }
          .document-item {
            flex-direction: column;
            align-items: flex-start;
            gap: 15px;
          }
          .download-btn {
            width: 100%;
            justify-content: center;
          }
          .document-count {
            font-size: 0.75rem;
            padding: 3px 10px;
          }
        }
      `}</style>
    </div>
  );
};

const DocumentsList = () => {
  return (
    <AppLayout isShowSlider={false}>
      <ContentDocuments />
    </AppLayout>
  );
};

export default DocumentsList;
